<template>
  <div>
    <section class="">
        <div class="flex-row section-container content-container legal">
            <div class="flex-column" v-html="articleBody">

            </div>
        </div>
    </section>
  </div>
</template>
<script>
import SvgIconContainer from '../components/Svg/SvgIconContainer.vue';
import markdownit from 'markdown-it';
import strapiServices from '../services/StrapiServices';

export default {
    components: {
        SvgIconContainer
    },
    mixins: [],
    data() {
        return {
            articleBody: "",
        };
    },
    created () {
        
    },
    computed: {

    },
    mounted() {
        this.getLegalDoc();
    },
    filters: {
        
    },
    methods: {
        async getLegalDoc() {
            try {
                let response = await strapiServices.GET_STRAPI("/privacy/");
                let articles = response.data;
                console.log(articles);

                this.newsArticles = articles;
                const md = markdownit()
                const result = md.render(this.newsArticles.policyContent);
                this.articleBody = result;
            } catch (err) {
                console.log(err);
            }
        }
    },
    watch:{

    } 
};</script>
<style lang="scss">
</style>
